// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let SystemMessage = require("../../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormRelay__Validators = require("./PropertyWizardFormRelay__Validators.bs.js");
let PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.bs.js");
let PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.bs.js");

function PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton(props) {
  let onEditForm = props.onEditForm;
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
    onClick: param => onEditForm(),
    disabled: props.disabled,
    children: "Continue editing"
  });
}

let EditButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton(props) {
  let onEditForm = props.onEditForm;
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
    onClick: param => onEditForm(),
    disabled: props.disabled,
    children: "Edit address"
  });
}

let EditAddressButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton(props) {
  let onSubmit = props.onSubmit;
  let match = PropertyWizardFormRelay.Context.use();
  let tmp;
  let tmp$1 = match.mode;
  if (typeof tmp$1 !== "object") {
    tmp = "Broadcast";
  } else {
    switch (tmp$1.TAG) {
      case "Edit" :
        tmp = "Save Changes";
        break;
      case "Rebroadcast" :
        tmp = "Rebroadcast";
        break;
      case "BroadcastQuietSeller" :
        tmp = "Broadcast";
        break;
    }
  }
  return JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
    onClick: param => onSubmit(),
    disabled: props.disabled,
    children: tmp
  });
}

let SubmitButton = {
  make: PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton
};

let convertFragment = PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftAttachmentStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_decode;

let FormStateFragment_localDraftAttachmentStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftAttachmentStatus_fromString;

let FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment_localDraftSaveStatus_decode = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_decode;

let FormStateFragment_localDraftSaveStatus_fromString = PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.Utils.localDraftSaveStatus_fromString;

let FormStateFragment = {
  localDraftAttachmentStatus_decode: FormStateFragment_localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: FormStateFragment_localDraftAttachmentStatus_fromString,
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftSaveStatus_decode: FormStateFragment_localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: FormStateFragment_localDraftSaveStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__GlobalValidityIndicator(props) {
  let currentStep = props.currentStep;
  let onSubmit = props.onSubmit;
  let onEditForm = props.onEditForm;
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_formState_graphql.node, convertFragment$1, props.formState);
  let geocodingStatus = formState.geocodingStatus;
  let draftSaveStatus = formState.draftSaveStatus;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewGlobalValidityIndicator_localDraft_graphql.node, convertFragment, props.draft);
  let formValid = PropertyWizardFormRelay__Validators.useIsFormValid(draft.fragmentRefs, formState.fragmentRefs);
  let formIsValid = Stdlib_Result.isOk(formValid);
  let onEditForm$1 = () => {
    if (formValid.TAG === "Ok") {
      return onEditForm(currentStep);
    } else {
      return onEditForm(formValid._0);
    }
  };
  let draftSubmitting;
  switch (draftSaveStatus) {
    case "FirstSaveInProgress" :
    case "SaveInProgress" :
      draftSubmitting = true;
      break;
    default:
      draftSubmitting = false;
  }
  let submitting = draftSubmitting || props.isSubmittingForm;
  if (formState.filesStatus.length !== 0 || formState.imagesStatus.length !== 0) {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "previewPageMessage",
      text: "Your attachments are being uploaded. Please wait...",
      type_: "warning",
      icon: false,
      handleOnDismiss: prim => {},
      children: JsxRuntime.jsxs(ViewStack.make, {
        space: "md",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
            onEditForm: onEditForm$1,
            disabled: submitting
          }),
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
            onSubmit: onSubmit,
            disabled: true
          })
        ]
      })
    });
  }
  if (geocodingStatus === "Called") {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "previewPageMessage",
      text: "The address is being validated. Please wait...",
      type_: "warning",
      icon: false,
      handleOnDismiss: prim => {},
      children: JsxRuntime.jsxs(ViewStack.make, {
        space: "md",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
            onEditForm: onEditForm$1,
            disabled: submitting
          }),
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
            onSubmit: onSubmit,
            disabled: true
          })
        ]
      })
    });
  }
  if (geocodingStatus === "ErrorDuplicateListing") {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "previewPageMessage",
      text: "This property is already on TAN. Please go back and check the address.",
      type_: "error",
      icon: false,
      handleOnDismiss: prim => {},
      children: JsxRuntime.jsxs(ViewStack.make, {
        space: "md",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditAddressButton, {
            onEditForm: onEditForm$1,
            disabled: submitting
          }),
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
            onSubmit: onSubmit,
            disabled: true
          })
        ]
      })
    });
  }
  if (!formIsValid) {
    return JsxRuntime.jsx(SystemMessage.make, {
      id: "previewPageMessage",
      text: "The form is incomplete or has a validation error. Click edit or one of the missing fields to correct.",
      type_: "error",
      icon: true,
      handleOnDismiss: prim => {},
      children: JsxRuntime.jsxs(ViewStack.make, {
        space: "md",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
            onEditForm: onEditForm$1,
            disabled: submitting
          }),
          JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
            onSubmit: onSubmit,
            disabled: true
          })
        ]
      })
    });
  }
  if (!formIsValid) {
    return null;
  }
  let tmp;
  switch (draftSaveStatus) {
    case "FirstSaveInProgress" :
    case "SaveInProgress" :
      tmp = "Preview. Your draft is being saved. Please wait...";
      break;
    case "NotSaved" :
    case "Saved" :
      tmp = "Preview";
      break;
    case "SaveFailed" :
      tmp = "Preview. Your draft could not be saved. You can continue editing but may lose progress";
      break;
  }
  return JsxRuntime.jsx(SystemMessage.make, {
    id: "previewPageMessage",
    text: tmp,
    type_: "warning",
    icon: true,
    handleOnDismiss: prim => {},
    children: JsxRuntime.jsxs(ViewStack.make, {
      space: "md",
      flexDirection: "row",
      children: [
        JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$EditButton, {
          onEditForm: onEditForm$1,
          disabled: submitting
        }),
        JsxRuntime.jsx(PropertyWizardRelay__Preview__GlobalValidityIndicator$SubmitButton, {
          onSubmit: onSubmit,
          disabled: submitting
        })
      ]
    })
  });
}

let make = PropertyWizardRelay__Preview__GlobalValidityIndicator;

exports.EditButton = EditButton;
exports.EditAddressButton = EditAddressButton;
exports.SubmitButton = SubmitButton;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
